import LandingTopbar from "../components/sections/LandingTopbar";
import LandingHero from "../components/sections/LandingHero";
import LandingLogos from "../components/sections/LandingLogos";
import LandingIntegrations from "../components/sections/LandingIntegrations";
import LandingFeatures from "../components/sections/LandingFeatures";
import LandingCallout from "../components/sections/LandingCallout";
import LandingCta from "../components/sections/LandingCta";
import LandingQuote from "../components/sections/LandingQuote";
import LandingAiBenefits from "../components/sections/LandingAiBenefits";
import LandingFooter from "../components/sections/LandingFooter";
import "./Landing.css";

const SECTION_ANCHORS = ["over-ons", "toepassing", "faq", "contact"];

function Landing() {
  return (
    <div className="landing-page">
      <LandingTopbar />
      <main className="landing-main">
        <LandingHero />
        <LandingLogos />
        <LandingIntegrations />
        <LandingFeatures />
        <LandingCallout />
        <LandingCta />
        <LandingQuote />
        <LandingAiBenefits />
        <LandingFooter />
        {SECTION_ANCHORS.map((id) => (
          <div key={id} id={id} className="landing-anchor" aria-hidden="true" />
        ))}
      </main>
    </div>
  );
}

export default Landing;
